/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventRaffleHistoryListListData model module.
 * @module model/EventsControllerDtoEventRaffleHistoryListListData
 * @version 1.0
 */
class EventsControllerDtoEventRaffleHistoryListListData {
    /**
     * Constructs a new <code>EventsControllerDtoEventRaffleHistoryListListData</code>.
     * @alias module:model/EventsControllerDtoEventRaffleHistoryListListData
     */
    constructor() { 
        
        EventsControllerDtoEventRaffleHistoryListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventRaffleHistoryListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventRaffleHistoryListListData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventRaffleHistoryListListData} The populated <code>EventsControllerDtoEventRaffleHistoryListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventRaffleHistoryListListData();

            if (data.hasOwnProperty('itemDrawNo')) {
                obj['itemDrawNo'] = ApiClient.convertToType(data['itemDrawNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('roundNo')) {
                obj['roundNo'] = ApiClient.convertToType(data['roundNo'], 'Number');
            }
            if (data.hasOwnProperty('itemDrawCount')) {
                obj['itemDrawCount'] = ApiClient.convertToType(data['itemDrawCount'], 'Number');
            }
            if (data.hasOwnProperty('ticketItemId')) {
                obj['ticketItemId'] = ApiClient.convertToType(data['ticketItemId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('rewardList')) {
                obj['rewardList'] = ApiClient.convertToType(data['rewardList'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventRaffleHistoryListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventRaffleHistoryListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['rewardList'] && !(typeof data['rewardList'] === 'string' || data['rewardList'] instanceof String)) {
            throw new Error("Expected the field `rewardList` to be a primitive type in the JSON string but got " + data['rewardList']);
        }

        return true;
    }


}



/**
 * @member {Number} itemDrawNo
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['itemDrawNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} roundNo
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['roundNo'] = undefined;

/**
 * @member {Number} itemDrawCount
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['itemDrawCount'] = undefined;

/**
 * @member {Number} ticketItemId
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['ticketItemId'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['createdAt'] = undefined;

/**
 * @member {String} rewardList
 */
EventsControllerDtoEventRaffleHistoryListListData.prototype['rewardList'] = undefined;






export default EventsControllerDtoEventRaffleHistoryListListData;

